import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExamsFilterService } from '@shared/components/exams-filter/exams-filter.service';
import { DatabaseService } from '../../../database/database.service';
import { ExamsService } from '../../views/exams/exams.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { formatDate } from '@angular/common';
import * as XLSX from 'xlsx-js-style';

@Component({
  selector: 'app-exams-filter',
  templateUrl: './exams-filter.component.html',
  styleUrls: ['./exams-filter.component.scss']
})
export class ExamsFilterComponent implements OnInit, OnDestroy {

  @Input() tipo: string;
  @Input() tiposExamen: any;
  @Output() dismissFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateCargadosOnParentList: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  public examFilter: FormGroup;
  subscription: Subscription;
  selectedCities: any[] = [];
  submitted = false;
  tipoDocumentoTrabajador: [];
  nombresExamen: [];
  tiposExamenFilter: [];
  tiposDictamen: [];
  isOnline: boolean;
  yearRange: any;
  date: Date;
  fieldsDisabled: boolean = false;
  botonHabilitado: boolean = false;
  errorMessage: string;

  constructor(
    private formBuilder: FormBuilder,
    private examsFilterService: ExamsFilterService,
    private databaseService: DatabaseService,
    private examsService: ExamsService,
    private connectionService: ConnectionService,
    private fb: FormBuilder,
    private http: HttpClient
  ) {

    const dniTipoFromOfflineDB = this.databaseService.getAlltiposDocumentoFromOfflineDB();
    dniTipoFromOfflineDB.then(data => {
      this.tipoDocumentoTrabajador = data;
    });

    const nombresExamenFromOfflineDB = this.databaseService.getAllNombresExamenFromOfflineDB();
    nombresExamenFromOfflineDB.then(data => {
      this.nombresExamen = data.sort((a, b) => b.descripcion.localeCompare(a.descripcion)).reverse();
    });

    const tipoExamenFromOfflineDB = this.databaseService.getAllTiposExamenFromOfflineDB();
    tipoExamenFromOfflineDB.then(data => {
      this.tiposExamenFilter = data;
    });

    const tipoDictamenFromOfflineDB = this.databaseService.getAllTiposDictamenFromOfflineDB();
    tipoDictamenFromOfflineDB.then(data => {
      this.tiposDictamen = data.filter(tipo => tipo.descripcion !== "Patológico" &&
      tipo.descripcion !== "Normal con valores anormales"? tipo : null);
    });
    this.isOnline = (localStorage.getItem('isStillOnline') === 'true');

    this.examFilter = this.fb.group({
      fechaCarga: [{ value: null, disabled: false }, Validators.required],
      empresaCuit: [{ value: null, disabled: false }],
      empresaRazonSocial: [{ value: null, disabled: false }],
      numeroLote: [{ value: null, disabled: false }], 
      tipoDocumentoTrabajador: [{ value: null, disabled: false }],
      nroDocumentoTrabajador: [{ value: null, disabled: false }],
      nombreExamen: [{ value: null, disabled: false }],
      tipoExamen: [{ value: null, disabled: false }],
      tipoDictamen: [{ value: null, disabled: false }],
      labelExamen: [{ value: null, disabled: false }], 
      labelVigencia: [{ value: null, disabled: false }],
      tipoEstudio: [{ value: null, disabled: false }],
      numeroCarpeta: [{ value: null, disabled: false }],
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    // this.clearFilter();

    if (this.tipo !== 'cargados') {
      this.onSubmit();
    }
  }

  ngOnInit(): void {
    let currentYear = new Date().getFullYear();
    this.yearRange = (currentYear - 2) + ':' + (currentYear);

    this.connectionService.monitor().subscribe( ( connected: ConnectionState ) => {
      const isConnected = connected.hasNetworkConnection;
      console.log( 'App en estado filter is offline ' + isConnected );
      this.checkEnabledButton();
      this.isOnline = isConnected;
    });

    const filtro = this.examsFilterService.getLocalAdvancedFilter(this.tipo);
    this.cargarFormulario(filtro);
    this.subscription = this.examsFilterService.clearFilterExams$.subscribe(res => {
      this.examFilter.reset();
    });

    if (this.tipo !== 'cargados') {
      const temp = this.tiposExamen;
      temp.sort((a, b) => b.label.localeCompare(a.label)).reverse();
      this.tiposExamen = [];
      temp.map((x) => {
        this.tiposExamen.push({descripcion: x.label, codigo: x.label});
      });
    } else {
      setTimeout(() => {
        this.tiposExamen = this.tiposExamen.sort((a, b) => {
          if (a.value < b.value) {
            return -1;
          }
          if (a.value > b.value) {
            return 1;
          }
          return 0;
        });
      }, 200);
    }

  }

  cargarFormulario(filtro) {

    if (this.tipo === 'cargados') {
      this.examFilter = this.formBuilder.group({
        empresaCuit: [filtro ? filtro.empresaCuit : null],
        empresaRazonSocial: [filtro ? filtro.empresaRazonSocial : null],
        numeroLote:[filtro ? filtro.numeroLote : null],
        tipoDocumentoTrabajador: [filtro ? filtro.tipoDocumentoTrabajador : null,],
        nroDocumentoTrabajador: [filtro ? filtro.nroDocumentoTrabajador : null,],
        nombreExamen:[filtro ? filtro.nombreExamen : null,],
        tipoExamen:[filtro ? filtro.tipoExamen : null,],
        tipoDictamen:[filtro ? filtro.tipoDictamen : null,],
        fechaCarga:[filtro ? filtro.fechaCarga : null, ], 
        numeroCarpeta:[filtro ? filtro.numeroCarpeta : null,],
      });
    } else {
      this.examFilter = this.formBuilder.group({
        labelVigencia: [filtro ? filtro.labelVigencia : [],],
        labelExamen: [filtro ? filtro.labelExamen : [],],
        tipoEstudio: [filtro ? filtro.tipoEstudio : null,],
        numeroLote: [filtro ? filtro.numeroLote : null,],
        numeroCarpeta: [filtro ? filtro.numeroCarpeta : null,],
        tipoDocumentoTrabajador: [filtro ? filtro.tipoDocumentoTrabajador : null,],
        nroDocumentoTrabajador: [filtro ? filtro.nroDocumentoTrabajador : null,]
      });
    }

  }

  onSubmit() {
    const data = this.examFilter.value;
    if (this.tipo === 'cargados') {

      localStorage.setItem('cargadosIsFirstSearch', 'false');
      this.examsFilterService.saveLocalAdvancedFilter(this.tipo, data);
      this.examsFilterService.setFilter({ data: data, tipo: this.tipo });
      this.closeSidebar.emit(false);
      
    } else {
      data.labelVigencia = data.labelVigencia ? data.labelVigencia : [];
      if (data.lote) {
        data.numeroLote = data.numeroLote.toString().replace(/[^0-9]/gi, '');
      }
      this.examsFilterService.saveLocalAdvancedFilter(this.tipo, data);
      this.examsFilterService.setFilter({ data: data, tipo: this.tipo });
      this.closeSidebar.emit(false);
    }

  }

  clearFilter() {
    this.examsFilterService.cleanFilter(this.tipo);
    this.examFilter.reset();
    this.examsFilterService.cleanLocalAdvancedFilter(this.tipo);

    if ( this.tipo === 'cargados') {
      this.examFilter.get('fechaCarga').reset();
      this.databaseService.cleanTable('examenesCargados');
    }
  }

  checkClearFilterButtonEnabled(){
    const fechaCarga = this.tipo === 'cargados' ? this.examFilter.get('fechaCarga').value : '';
    return (this.checkEnabledButton() 
    || (fechaCarga || fechaCarga !== ''));

  }

  checkEnabledButton() {
    const data = this.examFilter.value;
    const isStillOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    if (this.tipo === 'cargados' && !isStillOnline) {
      this.closeSidebar.emit(false);
      return false;
    }
    
    let tipoDocumentoTrabajador;
    let nroDocumentoTrabajador;
    let labelVigencia;
    let numeroCarpeta;
    let tipoEstudio;
    let numeroLote;
    let labelExamen;
    let tipoDictamen;
    let tipoExamen;
    let empresaCuit;
    let empresaRazonSocial;
    let nombreExamen;

    if (this.tipo === 'cargados') {
      tipoDictamen = this.examFilter.get('tipoDictamen').value;
      tipoExamen = this.examFilter.get('tipoExamen').value;
      nombreExamen = this.examFilter.get('nombreExamen').value;
      nroDocumentoTrabajador = this.examFilter.get('nroDocumentoTrabajador').value;
      tipoDocumentoTrabajador = this.examFilter.get('tipoDocumentoTrabajador').value;
      numeroCarpeta = this.examFilter.get('numeroCarpeta').value;
      numeroLote = this.examFilter.get('numeroLote').value;
      empresaRazonSocial = this.examFilter.get('empresaRazonSocial').value;
      empresaCuit = this.examFilter.get('empresaCuit').value;
    } else {
      tipoDocumentoTrabajador = this.examFilter.get('tipoDocumentoTrabajador').value;
      nroDocumentoTrabajador = this.examFilter.get('nroDocumentoTrabajador').value;
      labelVigencia = this.examFilter.get('labelVigencia').value;
      numeroCarpeta = this.examFilter.get('numeroCarpeta').value;
      tipoEstudio = this.examFilter.get('tipoEstudio').value;
      numeroLote = this.examFilter.get('numeroLote').value;
      labelExamen = this.examFilter.get('labelExamen').value;
    }
    


    if (this.tipo === 'cargados') {
      return (
        (tipoDocumentoTrabajador && nroDocumentoTrabajador !== '')
        || (tipoDocumentoTrabajador && tipoDocumentoTrabajador !== '')
        || (nroDocumentoTrabajador && nroDocumentoTrabajador !== '')
        || (empresaCuit && empresaCuit !== '')
        || (empresaRazonSocial && empresaRazonSocial !== '')
        || (numeroLote && numeroLote !== '')
        || (tipoEstudio && tipoEstudio !== '')
        || (tipoExamen && tipoExamen !== '')
        || (nombreExamen && nombreExamen !== '')
        || (tipoDictamen && tipoDictamen !== '')
        || (numeroCarpeta && numeroCarpeta !== '')
      );
    } else {
      return (
        (labelExamen && labelExamen.length > 0)
        || (labelVigencia && labelVigencia.length > 0) 
        || (tipoEstudio && tipoEstudio !== '') 
        || (numeroLote && numeroLote.toString().replace(/[^0-9]/gi, '') !== '')
        || (tipoDocumentoTrabajador && tipoDocumentoTrabajador !== '')
        || (nroDocumentoTrabajador && nroDocumentoTrabajador !== '')
        || (numeroCarpeta && numeroCarpeta !== '')
      );
    }
  }

  disableFields(event: any) {
    if (event) {
      this.examFilter.get('empresaCuit').disable();
      this.examFilter.get('empresaRazonSocial').disable();
      this.examFilter.get('numeroLote').disable();
      this.examFilter.get('nroDocumentoTrabajador').disable();
      this.examFilter.get('tipoDocumentoTrabajador').disable();
      this.examFilter.get('nombreExamen').disable();
      this.examFilter.get('tipoExamen').disable();
      this.examFilter.get('tipoDictamen').disable();
      this.examFilter.get('numeroCarpeta').disable();
      this.botonHabilitado = true;
    } else {
      this.examFilter.get('empresaCuit').enable();
      this.examFilter.get('empresaRazonSocial').enable();
      this.examFilter.get('numeroLote').enable();
      this.examFilter.get('nroDocumentoTrabajador').enable();
      this.examFilter.get('tipoDocumentoTrabajador').enable();
      this.examFilter.get('nombreExamen').enable();
      this.examFilter.get('tipoDictamen').enable();
      this.examFilter.get('tipoExamen').enable();
      this.examFilter.get('numeroCarpeta').enable();
      this.botonHabilitado = false;
    }
  }

  obtenerDatos() {
    const fechaCarga = this.examFilter.get('fechaCarga').value;
    const fechaCargaFormatted = formatDate(fechaCarga, 'yyyy-MM-dd', 'en-US');

    const body = {
       modelId: this.currentUser.modelId,
       filtros: [{
        'campo': 'fechaCarga',
        'valor': fechaCargaFormatted
      }]
     };

     const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    this.http.post(environment.apiUrl + 'estudios/obtenerCargados', body, { headers: headers })
      .subscribe((response: any) => {
    
        if (response && response.message) {
          if (response.message === 'No cuenta con exámenes pendientes de carga.') {
            this.errorMessage = 'No cuenta con exámenes cargados para esta fecha (' + fechaCargaFormatted + ').';
            setTimeout(() => {
              this.errorMessage = '';
            }, 5000); 
          } else {
            this.errorMessage = '';
            const filename = `estudiosCargados(${fechaCargaFormatted}).xlsx`;
            this.downloadExcel(response.message, filename);
          }
        }
      }, error => {
        console.error('Error al obtener datos de estudios cargados por fecha');
      });
  }

  downloadExcel(data: string, filename: string) {
    //Creacion de excel con libreria XLSX-STYLE.JS para estilado de celdas.
    const wb = XLSX.utils.book_new();

    // Define estilos para las celdas
    const headerStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "9cde9f" } },
      alignment: { horizontal: "center", vertical: "center" },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } }
      }
    };

    const cellStyle = {
      font: { name: "Arial", sz: 12 },
      alignment: { wrapText: true, horizontal: "center", vertical: "center", shrinkToFit: true },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } }
      }
    };

    // Crea la hoja de trabajo a partir de los datos CSV
    const worksheet = XLSX.utils.aoa_to_sheet(this.parseCSV(data));

    // Aplica estilos a las celdas de la cabecera
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = headerStyle;
    }

    // Aplica estilos a las celdas de datos
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = cellStyle;
      }
    }

    // Definir el ancho de las columnas
    const wscols = [
      { wch: 10 }, // Lote
      { wch: 15 }, // Carpeta
      { wch: 20 }, // DNI Trabajador
      { wch: 25 }, // Trabajador
      { wch: 30 }, // Nombre éxamen
      { wch: 20 }  // Fecha de Carga
    ];
    worksheet['!cols'] = wscols;

    // Altura de las filas
    const wsrows = [
      { hpt: 20 }, // Altura de la primera fila (cabecera)
    ];

    for (let R = 1; R <= range.e.r; ++R) {
      wsrows.push({ hpt: 100 }); // Altura de las filas de datos
    }

    worksheet['!rows'] = wsrows;

    // Añadimos la hoja al archivo
    XLSX.utils.book_append_sheet(wb, worksheet, "Datos");

    // Guardado en excel
    XLSX.writeFile(wb, filename);
  }

  parseCSV(data: string): any[][] {
    const rows = data.split('\n').filter(row => row.trim() !== '');
    return rows.map(row => row.split(',').map(cell => cell.replace(/(^")|("$)/g, '')));
  }
  
}
